/**
 * 框架标准接口，页面渲染前的数据处理
 *
 * 约等于接口拦截
 */
import interceptorsModule from '@/config/interceptors'
export default {
  // 批量修改-保存
  batchSave: async function (obj) {
    try {
      const { tableName } = vm.$route.params
      if (['PS_C_PRO','CP_C_WAREHOUSE','CP_C_RSTORE','CP_C_CUSTOMER'].includes(tableName)) {
        const { url, params } = obj
        const _this = this
        const formArr = _this.newformList.addcolums[0].childs
        const formV = _.cloneDeep(params.searchObject.data[tableName])
        const search = params.searchObject
        const income = {
          baseInfo: search,
          ids: params.searchObject.data.IDS,
          table: tableName,
          extendInfo: {
            data: []
          }
        }
        let extendAttr = {}, main = {}
        if (formV && Object.keys(formV).length) {
          for (const key in formV) {
            const dex = formArr.findIndex(i => i.colname == key)
            if (dex != -1 && formArr[dex].fieldMark && formArr[dex].fieldMark === 1) {
              // 动态属性
              delete search.data[tableName][key]
              delete search.after[tableName][key]
              const item = formArr[dex]
              const data = {
                column_name: key,
                column_value: formV[key],
                label: item.name,
                select_label: item.display == 'select' && formV[key] ? item.combobox.find((i) => i.limitval == formV[key]).limitdesc : ''
              };
              income.extendInfo.data.push(data);
              extendAttr[key] = formV[key]
            } else {
              // 主表字段
              main[key] = formV[key]
            }
          }
        }
        console.log('income::', income);
        $network.post('/api/cs/md/customBatchUpdate  ', income).then((res) => {
          if (typeof params.success === 'function') {
            params.success(res);
          }
        });
      } else {
        return true // 走原来的方法
      }
    } catch (error) {
      _this.loading = false
      console.error(error);
    }
  },
  preQueryList: async function (res) {
    try {
      const tableName = vm.$route.params.tableName
      if (['PS_C_PRO','CP_C_WAREHOUSE','CP_C_RSTORE','CP_C_CUSTOMER'].includes(tableName)) {
        res.api = '/api/cs/md/queryBaseDataList'
        const refs = $(`#${tableName}`)[0].__vue__.$refs
        if (refs && refs.R3listform) {
          const allForms = refs.R3listform.ItemLists // is object
          await refs.R3listform.getFormData().then(formvalue => {
            res.param.customColumns = {}
            let flag = false
            for (const key in formvalue) {
              let it = null
              if (Object.hasOwnProperty.call(allForms, key)) {
                it = allForms[key];
              }
              if (it && it.fieldMark == 1) { // 动态属性
                flag = true
                res.param.customColumns[key] = formvalue[key]
                delete res.param.fixedcolumns[key]
              }
            }
            if (!flag) {
              delete res.param.customColumns
            }
          })
          // 【查询】【导出】入参替换 - 商品品类
          const [oldColname, newColname] = interceptorsModule.category.tableArr.colnameMap.get(tableName);
          res.param.fixedcolumns[newColname] = res.param.fixedcolumns[oldColname]
          delete res.param.fixedcolumns[oldColname]
        }
      }
    } catch (error) {
      console.error(error);
      return res
    }
    return res
  },
  // 列表初始化接口入参等拦截处理
  preGetTableQuery: async function (res) {
    try {
      const tableName = vm.$route.params.tableName
      if (['PS_C_PRO','CP_C_WAREHOUSE','CP_C_RSTORE','CP_C_CUSTOMER'].includes(tableName)) {
        res.api = '/api/cs/md/getTableQueryField'
        res.paramStyle = 'json'
        const refs = $(`#${tableName}`)[0].__vue__.$refs
        if (refs && refs.R3listform) {
          await refs.R3listform.getFormData().then(formvalue => {
            res.param = Object.assign({}, res.param, { categoryId: formvalue.MODIFIERNAME ? formvalue.MODIFIERNAME.join() : null, categoryEname: $('#listForm #MODIFIERNAME .CATEGORY_NAME')[0].__vue__.valuedata })
            console.log('preGetTableQuery::res.param::', formvalue, res.param);
          })
        }
      }
    } catch (error) {
      return res
    }
    return res
  },
  // 列表初始化（按钮、查询表单、图例等）
  getTableQuery: async function (res) {
    const { data: { datas, tabcmd } } = res
    if (vm.$route.query && vm.$route.query.iframe) {
      // 在pos中的特殊处理
      if (['OC_B_ORDER_ALL', 'V_SG_B_STO_ADJUST_STORE'].includes(datas.table)) {
        const it1 = datas.dataarry.find(it => it.colname == 'CP_C_STORE_ID')
        if (it1) {
          it1.readonly = true
        }
      }
      if (['SG_B_STO_TOB_OUT_NOTICES_FRANCHISED', 'SG_B_STO_OUT_NOTICES_POS', 'SG_B_STO_IN_NOTICES_POS', 'SG_B_PHY_INVENTORY_EXT', 'SG_B_PHY_INVENTORY', 'SG_B_PHY_PROFIT', 'SG_B_STO_TOB_IN_NOTICES_FRANCHISED'].includes(datas.table)) {
        const it1 = datas.dataarry.find(it => it.colname == 'CP_C_PHY_WAREHOUSE_ID')
        if (it1) {
          it1.readonly = true
        }
      }
      if (['OC_B_RETURN_ORDER_ALL'].includes(datas.table)) {
        const it1 = datas.dataarry.find(it => it.colname == 'CP_C_PHY_WAREHOUSE_IN_ID')
        if (it1) {
          it1.readonly = true
        }
      }
      if (datas.table == 'SG_B_STO_TRANSFER_POS') {
        const it1 = datas.dataarry.find(it => it.colname == 'SENDER_STORE_ID')
        const it2 = datas.dataarry.find(it => it.colname == 'RECEIVER_STORE_ID')
        if (it1) {
          it1.readonly = true
        }
        /* if (it2) {
          it2.refcolprem = {
            "iswrite": "true",
            "refcol": "ID",
            "srccol": "SENDER_STORE_ID",
            "premtype": "CP_C_RELATION_STORE_ID"
          }
        } */
      }
      if (datas.table == 'SG_B_REQUISITION_ORDER') {
        const it1 = datas.dataarry.find(it => it.colname == 'RECEIVER_STORE_ID')
        const it2 = datas.dataarry.find(it => it.colname == 'SENDER_STORE_ID')
        if (it1) {
          it1.readonly = true
        }
        /* if (it2) {
          it2.refcolprem = {
            "iswrite": "true",
            "refcol": "ID",
            "srccol": "RECEIVER_STORE_ID",
            "premtype": "CP_C_RELATION_STORE_ID"
          }
        } */
      }
    }

    // ------ 双击不要进详情：------
    const noObjectView = ['V_SG_B_STO_STORE_DISTRIBUTION','V_COMMODITY_OPERATING_STATEMENT']
    if (noObjectView.includes(datas.table)) {
      tabcmd.prem[9] = false
    }

    // ------ 导出按钮展示：------
    const showExportTabArr = ['V_RPT_SOURCE_ORDER_DETAILS_QUERY', 'V_RPT_SOURCE_REFUND_DETAILS_QUERY', 'V_RPT_SOURCE_RETURN_DETAILS_QUERY']
    if (showExportTabArr.includes(datas.table)) {
      tabcmd.prem[8] = true
    }
    // ------ 平台店铺档案-defined字段列表处理：------
    if (datas.table == 'CP_C_SHOP') {
      let x = datas.dataarry.findIndex(it => it.colname == 'IS_EQUAL_EXCHANGE')
      if (x != -1) {
        datas.dataarry[x] = {
          "coldesc": "对等换货",
          "colname": "IS_EQUAL_EXCHANGE",
          "isuppercase": false,
          "display": "OBJ_SELECT",
          "webconf": null,
          "colid": 1700840472,
          "type": "STRING",
          "combobox": [
            {
              "limitdesc": "是",
              "limitdis": true,
              "limitval": "Y"
            },
            {
              "limitdesc": "否",
              "limitdis": false,
              "limitval": "N"
            }
          ]
        }
      }
    }
    //  ------ 商品品类 - 商品名称 defined处理：------
    /* if (datas.table == 'PS_C_CATEGORY') {
      let x = datas.dataarry.findIndex(it => it.colname == 'CATEGORY_NAME')
      if (x != -1) {
        datas.dataarry[x] = {
          "coldesc": "类目名称",
          "colname": "CATEGORY_NAME",
          "isuppercase": false,
          "webconf": null,
          "colid": 1700847742,
          "display": "defined",
          "type": "STRING"
        }
      }
    } */
    //  ------ 商品品类 defined处理：------
    interceptorsModule.category.handleStandardListFormDefined(datas, res)

    return res
  },
  // 列表数据查询（分页、表头、表格数据填充等）
  QueryList: async function (res) {
    // debugger
    const { data: { datas: { row, tabth, tabname } } } = res
    if (!row || (row && !row.length)) {
      res.data.datas.isFullRangeSubTotalEnabled = false
      res.data.datas.isSubTotalEnabled = false
    }
    if (tabname == 'PS_C_PRO_SN') {
      const dex = tabth.findIndex(i => i.colname == 'JSON_DATA')
      tabth.splice(dex, 1)
      vm.$store.commit("omsStore/up_PS_C_PRO_SN_CUSTOM_TABLE_DATA", JSON.parse(row[0].JSON_DATA.val));
    }
    // ------ 商品效期策略、寻源前拆单策略、商品基本属性、商品销售属性、商品品类-展示ID列：------
    const QueryListTables = new Map([
      ['ST_C_EXPIRY_DATE', '策略ID'],
      ['ST_C_SPLIT_BEFORE_SOURCE_STRATEGY', '策略ID'],
      ['PS_C_PRODIM', '属性ID'],
      ['PS_C_SALES_INFO', '属性ID'],
      ['PS_C_CATEGORY', '类目ID'],
    ])
    if ([...QueryListTables.keys()].includes(tabname)) {
      const _idIt = JSON.parse(JSON.stringify(tabth[0]))
      _idIt.colname = '_ID'
      _idIt.name = QueryListTables.get(tabname)
      _idIt.type = 'STRING'
      tabth.splice(0,0,_idIt)
      row.forEach(it => {
        it._ID = it.ID
      });
    }
    // ------ 调整页码：------
    const changePageTab = [
      'AC_F_COMMON_ORIGINAL_BILL','AC_F_ALIPAY_BILL_RAW_DATA','AC_F_PDD_ORIGINAL_BILL',
      'AC_F_DOUYIN_ORIGINAL_BILL','AC_F_CONFIRM_PLATFORM_BILL','AC_F_CONFIRM_BILL'
    ]
    const newRange = [ 10, 20, 30, 50, 100, 200, 500, 1000, 2000 ]
    if (changePageTab.includes(tabname)) {
      res.data.datas.selectrange = newRange
    }
    // ------ 平台店铺档案：------
    /* if (tabname == "CP_C_SHOP") {
      row.forEach(it => {
        if(it.IS_EQUAL_EXCHANGE.val) it.IS_EQUAL_EXCHANGE.val = it.IS_EQUAL_EXCHANGE.val == "Y" ? '是' : '否'
      });
    } */

    // res.data.datas.isFullRangeSubTotalEnabled = false // 关闭'总计'

    return res
  }
}
